// extracted by mini-css-extract-plugin
export default {"root":"ResizableSidebar_root__+1D3h","panel":"ResizableSidebar_panel__m+0b+","handle":"ResizableSidebar_handle__zvIpT","dragging":"ResizableSidebar_dragging__j7P6O"};